module.exports = __webpack_public_path__ + "img/infograph_1.2251fad1.png";